module.exports = __webpack_public_path__ + "static/media/Liberty_Logo_Horizontal_White.377e7b71.svg";